<!--
  ~ Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
  -->

<ngf-pseudo-checkbox [checked]="isChecked$ | async"
                     [disabled]="disabled$ | async"
                     [ariaDescribedby]="ariaDescribedby"
                     [ariaRequired]="computedAriaRequired"
                     [ariaInvalid]="isInvalid"
                     (checkedChange)="toggle($event)">
  <ng-content />
</ngf-pseudo-checkbox>
